import React from 'react';

export const LogoutIcon = () => (
  <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_373_13842)">
      <path
        d="M10.6875 1.6875C10.6875 1.03066 10.1568 0.5 9.5 0.5C8.84316 0.5 8.3125 1.03066 8.3125 1.6875V10C8.3125 10.6568 8.84316 11.1875 9.5 11.1875C10.1568 11.1875 10.6875 10.6568 10.6875 10V1.6875ZM5.3252 4.97539C5.82988 4.55605 5.89668 3.80645 5.47734 3.30176C5.05801 2.79707 4.3084 2.73027 3.80371 3.14961C1.84434 4.78242 0.59375 7.24648 0.59375 10C0.59375 14.917 4.58301 18.9062 9.5 18.9062C14.417 18.9062 18.4062 14.917 18.4062 10C18.4062 7.24648 17.152 4.78242 15.1926 3.14961C14.6879 2.73027 13.9383 2.80078 13.5189 3.30176C13.0996 3.80273 13.1701 4.55605 13.6711 4.97539C15.1146 6.17402 16.0275 7.98125 16.0275 10C16.0275 13.607 13.1033 16.5312 9.49629 16.5312C5.88926 16.5312 2.96504 13.607 2.96504 10C2.96504 7.98125 3.88164 6.17402 5.32148 4.97539H5.3252Z"
        fill="#637381"
      />
    </g>
    <defs>
      <clipPath id="clip0_373_13842">
        <rect width="19" height="19" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
